import React from 'react';

import CountryInfo from '../CountryInfo';

const PACKAGE_SECTION = {
    title: 'Stimulus Package',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Details</p>
            <ul>
                <li>
                    10 billion francs in emergency aid, with most of it
                    earmarked to support companies hit by slumping demand
                </li>
                <li>
                    Most of the money will be made available for companies
                    forced to go to short-time working, while the waiting time
                    before firms can apply for financial assistance has been
                    shortened.
                </li>
                <li>
                    For companies that are particularly badly hit, the
                    government said it has allocated 1 billion francs for direct
                    financial assistance or bridging finance.
                </li>
                <li>
                    Small and medium-sized business with financial bottlenecks
                    can access up to 580 million francs in guaranteed bank
                    loans.
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Swiss ramp up coronavirus response with $10.5 billion aid package',
            url: 'https://www.reuters.com/article/us-health-coronavirus-swiss/swiss-ramp-up-coronavirus-response-with-10-5-billion-aid-package-close-schools-idUSKBN2102C7?il=0',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'Switzerland',
    lastUpdated: 'March 17, 2020',
    introSection: (
        <p>
            Switzerland has announced a stimulus package of 10 billion swiss
            francs in assistance.
        </p>
    ),
    sections: [PACKAGE_SECTION],
};

const SwitzerlandInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default SwitzerlandInfo;
